import Page from "components/Page"
import usePageMeta from "hooks/usePageMeta"

interface Props {
  title: string
  lastUpdated: string
  path: string
  children: React.ReactNode
}

const LegalLayout = ({ title, lastUpdated, path, children }: Props) => {
  usePageMeta(`${title} — r4v3n`, undefined, undefined, path)
  return (
    <Page>
      <div className="max-w-3xl">
        <h1 className="gallery-heading mb-3">{title}</h1>
        <p className="gallery-label text-gallery-muted mb-10">Last updated {lastUpdated}</p>
        <div className="gallery-prose">{children}</div>
      </div>
    </Page>
  )
}

export default LegalLayout
